import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

import { RecoverabilityIndex as TRecoverabilityIndex } from "./recoverabilityIndex.types";

type RecoverabilityIndexProps = {
    recoverabilityIndex: TRecoverabilityIndex;
};

export const RecoverabilityIndex = ({
    recoverabilityIndex
}: RecoverabilityIndexProps) => {
    const { t } = useGranite();

    return (
        <div className={cn("tw:flex tw:mb-4")}>
            <img
                className={cn(
                    "tw:block tw:object-scale-down tw:object-left tw:max-w-full tw:h-18"
                )}
                src={recoverabilityIndex.imageUrl}
                alt={recoverabilityIndex.altText}
            />

            <div className={cn("tw:ml-4")}>
                <p className={cn("tw:mb-0")}>
                    {t("ecommerce.label.recoverabilityIndex.title")}
                </p>
                <a
                    className={cn(
                        "tw:block tw:text-sm tw:font-light tw:text-primary tw:cursor-pointer tw:hover:underline"
                    )}
                    href={Config["external-links"]["repairability-index"]}
                    target={"_blank"}
                    rel={"noopener"}
                >
                    {t("ecommerce.label.recoverabilityIndex.infoLink")}
                </a>
            </div>
        </div>
    );
};
